import Third1 from 'assets/main/third1.avif'
import Third2 from 'assets/main/third2.avif'
import Third3 from 'assets/main/third3.avif'
import { motion } from 'framer-motion'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'components/constants/animation-properties';
import Container from 'components/common/Container';

const Seventh = () => {
    const data = [
        {
            title: '수출입 준비, 클릭 한번에 완성',
            description: '출발지 · 목적지 · 상품 카테고리만 입력하면,<br class="wide:hidden block" />국가별 필수 서류와 작성 템플릿, HS 코드까지 자동 제안',
            list: [
                'Commerical Invoice, Parking List, 원산지증명서 등<br class="wide:hidden block" />국가 · 품목별 필수 서류를 즉시 정리',
                '작성 가이드 & 템플릿, 각 문서별 작성 요령과 <br class="wide:hidden block" />표준화된 템플릿 제공으로 실수 없이 서류 완성',
                'AI의 HS코드 추천을 통한 상품명 기반 최적 HS 코드 <br class="wide:hidden block" />제안, 예상 관세율 안내 및 대안 코드 비교'
            ],
            img: Third1
        },
        {
            title: '3D 시뮬레이션으로 안전과 효율 확보',
            description: '화물 크기 · 중량 · 수량 입력만으로 최적 적재 개수 · 순서와<br class="wide:hidden block" />리스크 이벤트를 한눈에 관리',
            list: [
                '3D 적재 시뮬레이터를 통해 컨테이너 · 트럭 · ULD별<br class="wide:hidden block" />화물 적재 가능 수량 및 순서를 실시간 3D 시각화',
                '화물 ID 및 이벤트 유형 입력 후 즉시 등록 · 관리,<br class="wide:hidden block" />해결 사례까지 안내',
                '고위험 화물을 자동으로 탐지하고 일어날수 있는<br class="wide:hidden block" />리스크에 대한 사전 경고 서비스'
            ],
            img: Third2
        },
        {
            title: '보험가입부터 분쟁 해결까지<br class="wide:hidden block" />원스톱 관리',
            description: '예상치 못한 손실에도 단계별 가이드로 빠르고<br class="wide:hidden block" />정확하게 대응하여 리스크를 최소화',
            list: [
                '사고 유형별 최적 보험 상품 추천 및 클레임 <br class="wide:hidden block" />처리 절차 안내등 보험 연계 가이드 활성화',
                '클레임 지원 템플릿을 통해 제출 서류 목록과<br class="wide:hidden block" />작성 예시를 제공해 신속한 보상 청구',
                '국제 분쟁 발생시 단계별로 플로우 차트를<br class="wide:hidden block" />통하여 해당 분쟁 메뉴얼을 명확히 제시'
            ],
            img: Third3
        },
    ]

    return (
        <Container className='flex flex-col items-start gap-[180px] wide:gap-20 py-[200px] wide:py-20 w-full min-h-dvh'>
            {
                data.map((item, idx) => (
                    <div
                        className={`flex ${idx % 2 !== 0 && 'flex-row-reverse self-end'} items-center justify-between wide:w-full wide:flex-col gap-20`}
                        key={idx}
                    >
                        <motion.div
                            className='overflow-hidden'
                            initial={START_ANIMATION_PROPERTY}
                            whileInView={END_ANIMATION_PROPERTY}
                            viewport={VIEWPORT_PROPERTY}
                        >
                            <img
                                className='hover:scale-95 transition-transform duration-300'
                                src={item.img}
                                alt="secondImg" />
                        </motion.div>
                        <div className='flex flex-col flex-1 gap-10 wide:gap-4 wide:w-full'>
                            <div>
                                <motion.p
                                    className='font-semibold text-28'
                                    transition={{ delay: 0.1 }}
                                    initial={START_ANIMATION_PROPERTY}
                                    whileInView={END_ANIMATION_PROPERTY}
                                    viewport={VIEWPORT_PROPERTY}
                                    dangerouslySetInnerHTML={{ __html: item.title }}
                                >
                                </motion.p>
                                <motion.p
                                    className='text-[#949494] text-lg'
                                    transition={{ delay: 0.2 }}
                                    initial={START_ANIMATION_PROPERTY}
                                    whileInView={END_ANIMATION_PROPERTY}
                                    viewport={VIEWPORT_PROPERTY}
                                    dangerouslySetInnerHTML={{ __html: item.description }}
                                >
                                </motion.p>
                            </div>
                            <ul className='flex flex-col gap-6 wide:gap-4 font-normal text-lg'>
                                {
                                    item.list.map((list, index) => (
                                        <motion.li
                                            transition={{ delay: 0.2 + 0.1 * index }}
                                            initial={START_ANIMATION_PROPERTY}
                                            whileInView={END_ANIMATION_PROPERTY}
                                            viewport={VIEWPORT_PROPERTY}
                                            className='flex items-center gap-6'
                                            key={index}
                                        >
                                            <p className='flex justify-center items-center bg-secondary rounded w-12.5 h-12.5 font-semibold text-white text-2xl shrink-0'>0{index + 1}</p>
                                            <p dangerouslySetInnerHTML={{ __html: list }}></p>
                                        </motion.li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                ))
            }
        </Container>
    )
}

export default Seventh